// extracted by css-extract-rspack-plugin
export default {"successMessage":"XRO15xQRQlcjvqsL"};